// extracted by mini-css-extract-plugin
module.exports = {"formGridUp":"personalData_formGridUp__M_NX_","gridLine":"personalData_gridLine__RtiDe","gridArea":"personalData_gridArea__3BygA"};